var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 " + _vm.size + " " + _vm.size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M9.28606 6.1167C9.75482 5.86293 10.2484 5.65804 10.7591 5.5053L11.5781 3.04688H14.4219L15.2409 5.50672C15.757 5.65886 16.2504 5.86503 16.7139 6.1167L19.0316 4.95645L21.0435 6.96698L19.8833 9.28606C20.135 9.75102 20.3411 10.243 20.4947 10.7591L22.9531 11.5781V14.4219L20.4933 15.2409C20.341 15.7515 20.1366 16.2451 19.8833 16.7139L21.0435 19.0316L19.033 21.0435L16.7139 19.8833C16.2452 20.1371 15.7516 20.342 15.2409 20.4947L14.4219 22.9531H11.5781L10.7591 20.4933C10.2485 20.341 9.75487 20.1366 9.28606 19.8833L6.96841 21.0435L4.95645 19.033L6.1167 16.7139C5.86293 16.2452 5.65804 15.7516 5.5053 15.2409L3.04688 14.4219V11.5781L5.50672 10.7591C5.65886 10.243 5.86503 9.74959 6.1167 9.28606L4.95645 6.96841L6.96698 4.95645L9.28606 6.1167ZM13 16.5547C13.9428 16.5547 14.8469 16.1802 15.5135 15.5135C16.1802 14.8469 16.5547 13.9428 16.5547 13C16.5547 12.0572 16.1802 11.1531 15.5135 10.4865C14.8469 9.81982 13.9428 9.44531 13 9.44531C12.0572 9.44531 11.1531 9.81982 10.4865 10.4865C9.81982 11.1531 9.44531 12.0572 9.44531 13C9.44531 13.9428 9.81982 14.8469 10.4865 15.5135C11.1531 16.1802 12.0572 16.5547 13 16.5547Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cf37a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cf37a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play_control/setting.vue
// module id = null
// module chunks = 